// extracted by mini-css-extract-plugin
export var heroImage = "_kv-1";
export var modal = "_kv-0";